import { useFragment } from '@apollo/client';
import { WorkspaceLimit } from '@frameio/graphql-client/generated';
import { useActiveAccountId } from '@frameio/shared/contexts';

export function useIsLimitedToOneWorkspace() {
  const accountId = useActiveAccountId();

  const { complete, data } = useFragment({
    fragment: WorkspaceLimit,
    fragmentName: 'WorkspaceLimit',
    from: {
      __typename: 'Account',
      id: accountId,
    },
  });

  if (!complete) return undefined;

  const workspaceLimit =
    data?.subscription?.limitedResources?.workspaces?.limit53;

  // if workspaceLimit is null, then the account is not limited
  return Boolean(
    workspaceLimit && Number.isInteger(workspaceLimit) && workspaceLimit <= 1
  );
}
